module.exports = __webpack_public_path__ + "static/img/02038B_2_C_20210310_fit.512e312.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02038B_2_C_20210310_fit.png
// module id = kvh3
// module chunks = 0